<script>

export default {
    name: 'Video'
}

</script>

<template>
    <div class="main">

        <div class="videobloco1">
            <img class="logo" src="../assets/imagens/logo-simbolo.png" alt="">
            <p class="titulo">Conheça a Nacional Indústria Metalúrgica Ltda</p>
            <p class="sub">E nossa dedicação à excelência em Usinagem, 
            Caldeiraria, Montagem e Manutenção Industrial.</p>
            <p class="text">Acompanhe o vídeo e descubra como nossa equipe qualificada transforma 
            desafios industriais em soluções inovadoras e de alta qualidade.</p>
        </div>
        <div class="videobloco2">
            <iframe class="video" src="https://drive.google.com/file/d/1MJHkOBYJ1FpmSU3eO98lHtVVV71dU_jj/preview"
                width="290" height="500" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
            </iframe>
        </div>





    </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
.main {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: 100vw;
    color: #000;
    background-color: #4444440a;
}

.videobloco1 {
    width: 95%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.videobloco2 {
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.video {
    border-radius: 10px;
    border: 5px solid #000;
    margin-top: 1rem;
}

.titulo{
    font-size: 1.3rem;
    margin: 3rem 0rem;
    font-family: "Staatliches", sans-serif;
    letter-spacing: 2px;
    color: #444;

}
.sub{
    font-size: 1rem;
    text-align: center;
    margin-bottom: 1rem ;
}

.text{
    font-size: 1.2rem;
    text-align: center;
    font-family: "Staatliches", sans-serif;
    letter-spacing: 1px;
    margin-top: 1rem;

}
.logo {
    width: 0%;
}
}
@media (min-width: 901px) {
.main {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    max-width: 100vw;
    color: #000;
    background-color: #4444440a;
}

.videobloco1 {
    width: 45%;
    height: 95vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.videobloco2 {
    width: 45%;
    height: 95vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.video {
    border-radius: 10px;
    border: 5px solid #000;
}

.titulo{
    font-size: 1.3rem;
    margin: 3rem 0rem;
    font-family: "Staatliches", sans-serif;
    letter-spacing: 2px;
    color: #444;

}
.sub{
    font-size: 1rem;
    text-align: center;
    margin-bottom: 1rem ;
}

.text{
    font-size: 1.2rem;
    text-align: center;
    font-family: "Staatliches", sans-serif;
    letter-spacing: 1px;
    margin-top: 1rem;

}
.logo {
    width: 20%;
}
}
</style>